import Router from "vue-router";
import store from '../src/store'
import {getToken} from '../src/utils/auth'
import {checkAndHandleCrossAppLogout} from '../src/utils/crossAppLogout'
import {parseJwtPayload} from '../src/utils/utils'
import Vue from "vue";
Vue.use(Router);
const adminLoginUrl = process.env.VUE_APP_ADMIN_LOGIN_URL || `${process.env.VUE_APP_ADMIN_URL || ''}/login`;
const vueRouter = new Router({
  base: process.env.VUE_APP_PATH,
  mode: process.env.VUE_APP_MODE,
  routes: [
    {
      path: "/",
      component: () => import(/* webpackChunkName: "page" */ "@/page/index"),
      children: [
        {
          path: "",
          component: () => import(/* webpackChunkName: "page" */ "@/page/list"),
        },
        {
          path: "category",
          component: () =>
            import(/* webpackChunkName: "page" */ "@/page/list/category"),
        },
        {
          path: "db",
          component: () =>
            import(/* webpackChunkName: "page" */ "@/page/list/db"),
        },
        {
          path: "map",
          component: () =>
            import(/* webpackChunkName: "page" */ "@/page/list/map"),
        },
        {
          path: "document",
          component: () =>
            import(/* webpackChunkName: "page" */ "@/page/list/document"),
        },
      ],
    },
    {
      path: "/create",
      name: "create",
      component: () => import(/* webpackChunkName: "page" */ "@/page/create"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import(/* webpackChunkName: "page" */ "@/page/login"),
    },
    {
      path: "/build/:id",
      name: "build",
      component: () => import(/* webpackChunkName: "page" */ "@/page/build"),
    },
    {
      path: "/view/:id",
      name: "view",
      component: () => import(/* webpackChunkName: "page" */ "@/page/view"),
    },
    {
      path: "/404",
      name: "404",
      component: () => import(/* webpackChunkName: "page" */ "@/components/404.vue"),
    },
    {
      path: '*',
      redirect: '/404'
    },
  ],
});
export default vueRouter;

vueRouter.beforeEach((to, from, next) => {
  // 检查跨应用登出标记
  if (checkAndHandleCrossAppLogout()) {
    if (adminLoginUrl) {
      window.location.href = adminLoginUrl;
      return;
    }
    return next('/login');
  }
  
  // 1.如果访问的是登录页面（无需权限），直接放
  if (to.path === "/login"){
    if (adminLoginUrl) {
      window.location.href = adminLoginUrl;
      return;
    }
    return next();
  }else{
    sessionStorage.setItem('redirectUrl',to.path)
  }
  // 2.如果访问的是有登录权限的页面，先要获取token
  var tokenStr = getToken();
  // 2.1如果token为空，强制跳转到登录页面（部分大屏页面除外）
  if (tokenStr===undefined 
    && to.path.indexOf('1580367951982809090') < 0 
    && to.path.indexOf('1580028688846135297') < 0
    && to.path.indexOf('1580478418252300290') < 0
    && to.path.indexOf('1580478168477302785') < 0
    && to.path.indexOf('1580372464726757378') < 0) {
    if (adminLoginUrl) {
      window.location.href = adminLoginUrl;
      return;
    }
    return next('/login');
  }
  // 2.2 有 token 但 userInfo 为空或非当前用户（如从管理前端跳转过来）：拉取当前用户信息
  var userInfo = store.getters.userInfo;
  var payload = parseJwtPayload(tokenStr);
  var tokenUser = payload && payload.account;
  var needUserInfo =  !userInfo ||  !userInfo.account ||  !tokenUser || userInfo.account !== tokenUser;
  // console.log(userInfo)
  // console.log(tokenStr)
  // console.log(needUserInfo)
  // console.log(payload)
  // console.log(tokenUser)
  if (tokenStr && needUserInfo) {
    store.dispatch('GetUserInfo').then(() => next()).catch(() => next());
  } else {
    next();
  }
});

